import { IJobEducation1, IJobEducation2, IJobFamily, IJobExpJob, IJobExpInfo, IJobEducation3 } from './../constants/models';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var JobService = /** @class */ (function () {
    function JobService(http) {
        this.http = http;
        this.isTesting = false;
    }
    // List รายการตำแหน่งงาน
    JobService.prototype.getJobList = function () {
        var URL = cmsApi + '/getjobList';
        var body = {};
        return this.http.post(URL, body);
    };
    // รายละเอียดงาน
    JobService.prototype.getJobDetail = function (bi) {
        var URL = cmsApi + '/getjobDetail';
        var body = { id: bi };
        return this.http.post(URL, body);
    };
    JobService.prototype.upload_blob_to_cloud = function (data, file_type) {
        var URL = 'http://localhost:8000/api/cloud/uploadblobtocloud/';
        var body = {
            data: data,
            file_type: file_type
        };
        return this.http.post(URL, body);
    };
    // add_job_register
    JobService.prototype.setApply_Personal = function (expected_salary, title_th, fname_th, lname_th, title_en, fname_en, lname_en, tel, mobile, email, birthday, age, identity, domicile, nationality, religion, contact_address, jobid, yearType, address, military_status) {
        var URL = cmsApi + '/add_job_register';
        var body = {
            expected_salary: expected_salary,
            title_th: title_th,
            fname_th: fname_th,
            lname_th: lname_th,
            title_en: title_en,
            fname_en: fname_en,
            lname_en: lname_en,
            tel: tel,
            mobile: mobile,
            email: email,
            birthday: birthday,
            age: age,
            identity: identity,
            domicile: domicile,
            nationality: nationality,
            religion: religion,
            contact_address: contact_address,
            jobid: jobid,
            yearType: yearType,
            address: address,
            military_status: military_status
        };
        if (this.isTesting) {
            console.log('body setApply_Personal', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            console.log('body setApply_Personal', body);
            return this.http.post(URL, body);
        }
    };
    // UploadFile_education
    JobService.prototype.UploadFile_education = function (fileItem) {
        // const uploadUrl = cmsApi + '/datadetails';
        var uploadUrl = cmsApi + '/UploadFile_education';
        var uploadFormData = new FormData();
        uploadFormData.append('file', fileItem);
        var body = uploadFormData;
        return this.http.post(uploadUrl, body);
    };
    // add_job_register_education1
    JobService.prototype.setEducation_1 = function (personid, education, NameOfInstitute, major, graduate, FromMonthYear, ToMonthYear, gpa, seq, educationOther) {
        var URL = cmsApi + '/add_job_register_education1';
        var body = {
            personid: personid,
            education: education,
            NameOfInstitute: NameOfInstitute,
            major: major,
            graduate: graduate,
            FromMonthYear: FromMonthYear,
            ToMonthYear: ToMonthYear,
            gpa: gpa,
            seq: seq,
            educationOther: educationOther,
        };
        if (this.isTesting) {
            console.log('body setEducation_1', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    JobService.prototype.setEducations_1 = function (params) {
        var URL = cmsApi + '/add_job_register_educations1';
        if (this.isTesting) {
            console.log('body setEducations_1', params);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, params);
        }
    };
    // add_job_register_education2
    JobService.prototype.setEducations_2 = function (param) {
        var URL = cmsApi + '/add_job_register_educations2';
        if (this.isTesting) {
            console.log('body setEducation_2', param);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, param);
        }
    };
    JobService.prototype.setEducation_2 = function (personid, file1, language, speaking, understanding, reading, writting, seq) {
        var URL = cmsApi + '/add_job_register_education2';
        var body = {
            personid: personid,
            file1: file1,
            language: language,
            speaking: speaking,
            understanding: understanding,
            reading: reading,
            writting: writting,
            seq: seq
        };
        if (this.isTesting) {
            console.log('body setEducation_2', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_education3
    JobService.prototype.setEducation_3 = function (personid, licenseName, licenseNo, licenseDate, seq) {
        var URL = cmsApi + '/add_job_register_education3';
        var body = {
            personid: personid,
            licenseName: licenseName,
            licenseNo: licenseNo,
            licenseDate: licenseDate,
            seq: seq
        };
        if (this.isTesting) {
            console.log('body setEducation_3', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    JobService.prototype.setEducations_3 = function (params) {
        var URL = cmsApi + '/add_job_register_educations3';
        if (this.isTesting) {
            console.log('body setEducations_3', params);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, params);
        }
    };
    // add_job_register_education4
    JobService.prototype.setEducation_4 = function (body) {
        var URL = cmsApi + '/add_job_register_education4';
        if (this.isTesting) {
            console.log('body setEducation_4', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_family_age
    JobService.prototype.setAge = function (itemid, itemaage, seq) {
        var URL = cmsApi + '/add_job_register_family_age';
        var body = {
            personid: itemid,
            age: itemaage,
            seq: seq
        };
        if (this.isTesting) {
            console.log('body AGE', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_family
    JobService.prototype.setfamilies = function (param) {
        var URL = cmsApi + '/add_job_register_families';
        if (this.isTesting) {
            console.log('Family', param);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, param);
        }
    };
    JobService.prototype.setfamily = function (personid, MaritalStatus, NumberChildren, f_title, f_fname, f_lname, f_age, f_occupation, f_address, f_tel, m_title, m_fname, m_lname, m_age, m_occupation, m_address, m_tel, urgent_title, urgent_fname, urgent_lname, urgent_tel, urgent_address, urgent_relation, s_title, s_fname, s_lname, s_age, s_occupation, s_address, s_tel) {
        var URL = cmsApi + '/add_job_register_family';
        var body = {
            personid: personid,
            MaritalStatus: MaritalStatus,
            NumberChildren: NumberChildren,
            f_title: f_title,
            f_fname: f_fname,
            f_lname: f_lname,
            f_age: f_age,
            f_occupation: f_occupation,
            f_address: f_address,
            f_tel: f_tel,
            m_title: m_title,
            m_fname: m_fname,
            m_lname: m_lname,
            m_age: m_age,
            m_occupation: m_occupation,
            m_address: m_address,
            m_tel: m_tel,
            urgent_title: urgent_title,
            urgent_fname: urgent_fname,
            urgent_lname: urgent_lname,
            urgent_tel: urgent_tel,
            urgent_address: urgent_address,
            urgent_relation: urgent_relation,
            s_title: s_title,
            s_fname: s_fname,
            s_lname: s_lname,
            s_age: s_age,
            s_occupation: s_occupation,
            s_address: s_address,
            s_tel: s_tel,
        };
        if (this.isTesting) {
            console.log('Family', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_family_brother_sister
    JobService.prototype.setbrother = function (personid, b_title, b_fname, b_lname, b_age, b_occupation, b_address, b_tel, seq) {
        var URL = cmsApi + '/add_job_register_family_brother_sister';
        var body = {
            personid: personid,
            b_title: b_title,
            b_fname: b_fname,
            b_lname: b_lname,
            b_age: b_age,
            b_occupation: b_occupation,
            b_address: b_address,
            b_tel: b_tel,
            seq: seq
        };
        if (this.isTesting) {
            console.log('setbrother', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_s_family
    JobService.prototype.setSpouse = function (personid, s_title, s_fname, s_lname, s_age, s_occupation, s_address, s_tel) {
        var URL = cmsApi + '/add_job_register_s_family';
        var body = {
            personid: personid,
            s_title: s_title,
            s_fname: s_fname,
            s_lname: s_lname,
            s_age: s_age,
            s_occupation: s_occupation,
            s_address: s_address,
            s_tel: s_tel,
        };
        if (this.isTesting) {
            console.log('setSpouse', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_experience_lastJob
    JobService.prototype.setExperienceLastJobs = function (param) {
        var URL = cmsApi + '/add_job_register_experience_lastJobs';
        if (this.isTesting) {
            console.log('setExperienceLastJob body: ', param);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, param);
        }
    };
    JobService.prototype.setExperienceLastJob = function (body) {
        var URL = cmsApi + '/add_job_register_experience_lastJob';
        if (this.isTesting) {
            console.log('setExperienceLastJob body: ', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_experience_reference
    JobService.prototype.setExperienceReference = function (personid, ref_title, ref_fname, ref_lname, ref_position, ref_tel, ref_relation, seq) {
        var URL = cmsApi + '/add_job_register_experience_reference';
        var body = {
            personid: personid,
            ref_title: ref_title,
            ref_fname: ref_fname,
            ref_lname: ref_lname,
            ref_position: ref_position,
            ref_tel: ref_tel,
            ref_relation: ref_relation,
            seq: seq
        };
        if (this.isTesting) {
            console.log('setExperienceReference body: ', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    // add_job_register_experience
    JobService.prototype.setCheckExperiences = function (param) {
        var URL = cmsApi + '/add_job_register_experiences';
        if (this.isTesting) {
            console.log('setCheckExperience body: ', param);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, param);
        }
    };
    JobService.prototype.setCheckExperience = function (personid, flag_illegal, illegal_remark, flag_NotPerfect, NotPerfect_remark, flag_sack, sack_remark, flag_WorkWithAsset, WorkWithAsset_reamrk, flag_confirm, flag_pdpa) {
        var URL = cmsApi + '/add_job_register_experience';
        var body = {
            personid: personid,
            flag_illegal: flag_illegal,
            illegal_remark: illegal_remark,
            flag_NotPerfect: flag_NotPerfect,
            NotPerfect_remark: NotPerfect_remark,
            flag_sack: flag_sack,
            sack_remark: sack_remark,
            flag_WorkWithAsset: flag_WorkWithAsset,
            WorkWithAsset_reamrk: WorkWithAsset_reamrk,
            flag_confirm: flag_confirm,
            flag_pdpa: flag_pdpa,
        };
        if (this.isTesting) {
            console.log('setCheckExperience body: ', body);
            return new Observable(function (subscriber) {
                setTimeout(function () {
                    subscriber.next({ 'returncode': '1000', 'personid': '111111111' });
                }, 100);
            });
        }
        else {
            return this.http.post(URL, body);
        }
    };
    JobService.ngInjectableDef = i0.defineInjectable({ factory: function JobService_Factory() { return new JobService(i0.inject(i1.HttpClient)); }, token: JobService, providedIn: "root" });
    return JobService;
}());
export { JobService };
